import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OrdenTrabajoDTO } from "app/main/apps/shared/interfaces/orden-trabajo.interface";

@Component({
    selector: "app-dialog-ticket",
    templateUrl: "./dialog-ticket.component.html",
    styleUrls: ["./dialog-ticket.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogTicketComponent implements OnInit {
    formTicket: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogTicketComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OrdenTrabajoDTO,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        //console.log(this.data);
        this.formTicket = this.fb.group({
            nroTicket: [
                this.data.ticket || null,
                { validators: [Validators.required] },
            ],
        });
    }

    get nroTicket() {
        return this.formTicket.get("nroTicket");
    }
}
